/**
 * Application Configuration
 * Central export for all config values
 */

export { env, isAIEnabled, isDev, isProd, isStaging } from './env';
export type { Env } from './env';

// App constants
export const APP_CONFIG = {
  name: 'Invoice Agent',
  description: 'AI-powered invoice generation with zero server-side storage',
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',

  // Storage keys
  storage: {
    draft: 'invoice_agent_draft',
    history: 'invoice_agent_history',
    theme: 'invoice_agent_theme',
    settings: 'invoice_agent_settings',
  },

  // Feature flags
  features: {
    voiceAssistant: true,
    pdfExport: true,
    multiTemplate: true,
    darkMode: true,
  },

  // Limits
  limits: {
    maxInvoiceHistory: 50,
    maxLineItems: 100,
    maxLogoSize: 2 * 1024 * 1024, // 2MB
  },
} as const;
